import { gql } from '@apollo/client';
import { getApolloClient } from '~/singlePageApp/getApolloClient';

// eslint-disable-next-line rulesdir/no-gql-tags -- TODO: migrate to graphql-codegen
const PUSH_METRICS_GQL_MUTATION = gql`
  mutation pushMetrics($metricsArray: PushMetricsInput!) {
    pushMetrics(input: $metricsArray) {
      success
    }
  }
`;

type Metric = {
  metricType: string;
  name: string;
  value: unknown;
  tags: unknown[];
};

export const pushMetrics = async (metrics: Metric[]): Promise<unknown> => {
  const client = getApolloClient({}, {}, 'AnonymousSchema');

  //  FIXME: Type this out via Apollo Code Gen. Should be the 'PushMetricsPayload' type from the code generator.
  //  See https://app.shortcut.com/wistia-pde/story/8394/typescript-graphql-codegen-for-typescript-based-off-graphql-schema
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { data } = await client.mutate({
    mutation: PUSH_METRICS_GQL_MUTATION,
    fetchPolicy: 'network-only',
    variables: {
      metricsArray: {
        metrics,
      },
    },
  });

  //  FIXME: Type this out via Apollo Code Gen. Should be the 'PushMetricsPayload' type from the code generator.
  //  See https://app.shortcut.com/wistia-pde/story/8394/typescript-graphql-codegen-for-typescript-based-off-graphql-schema

  return data;
};

export const makeMetric = (
  metricType: string,
  name: string,
  value: unknown,
  tags: unknown[] = [],
): Metric => {
  return {
    metricType,
    name,
    value,
    tags,
  };
};

export const count = async (
  name: string,
  value: unknown,
  tags: unknown[],
): ReturnType<typeof pushMetrics> => {
  return pushMetrics([makeMetric('count', name, value, tags)]);
};

export const increment = async (name: string, tags?: unknown[]): ReturnType<typeof pushMetrics> => {
  return pushMetrics([makeMetric('count', name, 1.0, tags)]);
};

export const decrement = async (name: string, tags?: unknown[]): ReturnType<typeof pushMetrics> => {
  return pushMetrics([makeMetric('count', name, -1.0, tags)]);
};

export const gauge = async (
  name: string,
  value: unknown,
  tags?: unknown[],
): ReturnType<typeof pushMetrics> => {
  return pushMetrics([makeMetric('gauge', name, value, tags)]);
};

export const histogram = async (
  name: string,
  value: unknown,
  tags?: unknown[],
): ReturnType<typeof pushMetrics> => {
  return pushMetrics([makeMetric('histogram', name, value, tags)]);
};

export const distribution = async (
  name: string,
  value: unknown,
  tags?: unknown[],
): ReturnType<typeof pushMetrics> => {
  return pushMetrics([makeMetric('distribution', name, value, tags)]);
};
